import React from "react";
import { Divider } from "@mui/material";
import { useCustomThemeContext } from "../../providers/customThemeProvider";

interface DividerHorizontalProps {
  size?: number;
}

// Define the DividerHorizontal functional component
const DividerHorizontal: React.FC<DividerHorizontalProps> = ({ size = 1 }) => {
  // Get the theme from the MUI theme provider
  const { theme } = useCustomThemeContext();

  return (
    // Render the Divider component with custom styles
    <Divider
      data-testid="hor-divider" // Test ID for the horizontal divider
      sx={{ borderBottom: size, borderColor: theme.palette.primary.main }} // Apply custom styles to the divider
    />
  );
};

export default DividerHorizontal;
